import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation revokeAdminMutation($input: RevokeAdminInput!) {
    revokeAdmin(input: $input) {
      lists {
        ...AdminList_lists
      }
      revokedAdminIds
    }
  }
`;

const revokeAdmin = (environment, userId, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id: userId,
      },
    },
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [{ key: 'AdminList_adminUsers' }],
        pathToConnection: ['lists', 'adminUsers'],
        deletedIDFieldName: 'revokedAdminIDs',
      },
    ],
    ...args,
  });
};

export default revokeAdmin;
